export default "__VITE_ASSET__BBSl32Pj__"